const replaceUndefinedWithNull = (val: any): any => {
  if (typeof val === 'undefined') {
    return null;
  }

  if (val instanceof Array) {
    return val.map(replaceUndefinedWithNull);
  }

  if (typeof val === 'object' && val != null) {
    return Object.entries(val).reduce((result, [key, value]) => {
      result[key] = replaceUndefinedWithNull(value);

      return result;
    }, {});
  }

  return val;
};

export default replaceUndefinedWithNull;
